import { Font, StyleSheet } from '@react-pdf/renderer';
Font.registerHyphenationCallback(word => {
  return [word];
});

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 0,

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',

    width: '100%',
    height: 100,
  },
  footerColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 5,
    paddingVertical: 20,
    height: 100,
  },
  footerMiddleItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 5,

    color: 'white',
    fontSize: 14,
    fontFamily: 'Lato',
    textAlign: 'center',
    width: '100%',
  },
  logo: {
    width: 130,
    height: 40,
    objectFit: 'contain',
  },
  icon: {
    width: 12,
    height: 12,
    objectFit: 'cover',
  },
});

export const globalStyles = StyleSheet.create({
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    paddingTop: 40,
  },
  title: {
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    paddingLeft: 53,
    textTransform: 'uppercase',
  },
  bigTitle: {
    fontSize: 40,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    paddingLeft: 53,
    paddingRight: 53,
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap',
    hyphenationCallback: (word: string) => [word],
  },
  mediumTitle: {
    fontWeight: 700,
    fontSize: 24,
    fontFamily: 'Lato',
    marginLeft: 53,
    marginRight: 53,
  },
  lineBar: {
    borderTop: '3px solid black',
    marginLeft: 53,
    marginTop: 10,
    width: 100,
  },
  boldText: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    paddingLeft: 53,
  },
  regularText: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingLeft: 53,
    paddingRight: 53,
  },
  lightPointText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingLeft: 53,
  },
  lightText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingRight: 130,
  },
});
